/* eslint-disable default-case */
import buildFormattingTokensRegExp from "date-fns/locale/_lib/build_formatting_tokens_reg_exp";
import { buildDistanceInWordsLocale } from "./DateDistanceLocalisation";
const buildFormatLocale = t => {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  const months3char = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthsFull = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const weekdays2char = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const weekdays3char = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const weekdaysFull = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const meridiemUppercase = ["AM", "PM"];
  const meridiemLowercase = ["am", "pm"];
  const meridiemFull = ["a.m.", "p.m."];
  const formatters = {
    // Month: Jan, Feb, ..., Dec
    MMM: date => {
      return t(months3char[date.getMonth()]);
    },
    // Month: January, February, ..., December
    MMMM: date => {
      return t(monthsFull[date.getMonth()]);
    },
    // Day of week: Su, Mo, ..., Sa
    dd: date => {
      return t(weekdays2char[date.getDay()]);
    },
    // Day of week: Sun, Mon, ..., Sat
    ddd: date => {
      return t(weekdays3char[date.getDay()]);
    },
    // Day of week: Sunday, Monday, ..., Saturday
    dddd: date => {
      return t(weekdaysFull[date.getDay()]);
    },
    //, AM, PM
    A: date => {
      return date.getHours() / 12 >= 1 ? t(meridiemUppercase[1]) : t(meridiemUppercase[0]);
    },
    //, am, pm
    a: date => {
      return date.getHours() / 12 >= 1 ? t(meridiemLowercase[1]) : t(meridiemLowercase[0]);
    },
    // a.m., p.m.
    aa: date => {
      return date.getHours() / 12 >= 1 ? meridiemFull[1] : meridiemFull[0];
    }
  };

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  const ordinalFormatters = ["M", "D", "DDD", "d", "Q", "W"];
  ordinalFormatters.forEach(formatterToken => {
    formatters[`${formatterToken}o`] = function (date, formatters) {
      return ordinal(t, formatters[formatterToken](date));
    };
  });
  return {
    formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  };
};
const ordinal = (t, number) => {
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return t("{0}st", number);
      case 2:
        return t("{0}nd", number);
      case 3:
        return t("{0}rd", number);
    }
  }
  return t("{0}th", number);
};
export const locale = (translate, expertFormat = false) => {
  return {
    distanceInWords: buildDistanceInWordsLocale(translate, expertFormat),
    format: buildFormatLocale(translate)
  };
};